<template>
    <div>
        <card-header title="Registration Types/Fees" icon="fa-usd-square"></card-header>

        <card-toolbar>
            <button @click="$openCard('conf-new-type', {confId: conference.id}, card)"><i class="far fa-plus"></i>New Type/Fee</button>
        </card-toolbar>

        <card-body>
            <card-list>

                <draggable v-model="conference.regTypes" handle=".handle" @change="updateOrder">
                    <transition-group>
                        <conf-type-tile
                            :card="card"
                            :type="type"
                            v-for="type in conference.regTypes"
                            @click="$openCard('conf-edit-type', {confId: props.confId, typeId: type.id}, card)"
                            :active="(child && child.definition.component === 'conf-edit-type' && type.id === parseInt(child.props.typeId))"
                            class="t-card-list-item"
                            :key="type.id"
                        />
                    </transition-group>
                </draggable>


            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import CardToolbar from "@/TIER/components/CardToolbar";

    import {client as http} from '@/http_client';
    import ConfTypeTile from "../../../components/tiles/ConfTypeTile";
    import ConfQuestionTile from "../../../components/ConfQuestionTile.vue";

    import draggable from 'vuedraggable';

    export default {
        components: {ConfQuestionTile, ConfTypeTile, CardToolbar, CardList, CardHeader, CardBody, draggable},
        props: ['card', 'props', 'child'],
        data() {
            return {
                conference: {}
            };
        },
        methods: {
            loadConference: function (force) {
                this.$emit('loading', true);
                http.get('conferences/' + this.props.confId, {force}).then(response => {
                    this.conference = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            updateOrder: function () {
                let order = [];
                for (let i = 0; i < this.conference.regTypes.length; i++) {
                    order.push(this.conference.regTypes[i].id)
                }
                http.post('conferences/' + this.props.confId + '/types/order', {order}).then(response => {

                }).catch(err => {

                });
            },
            reload: function () {
                this.loadConference(true);
            }
        },
        mounted() {
            this.loadConference();
        }
    }
</script>

<style>

</style>
